import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
// import VAALogo from "../assets/logo.png";
// import vastuSalahkar from "../assets/vastuSalahkar.png";
import vastuSalahkar4 from "../assets/vastuSalahkar4.png";
import { productSubCategories, getCartItems } from "../api/Product.services";
import {requestOtp,loginRegisterVerifyOtp,getUserCurrentLocation, fetchUserAddresses, updateUser, fetchUserDetails, addAddress, updateAddress, VerifyOtpAfterLogin} from "../api/AuthApi.services"
import CountryStateCitySelector from "./CountryStateCitySelector";
import {Country, State, City } from "country-state-city";
import "./Navbar.css";
import SearchBar from "./Search"; // Import SearchBar

function Navbar({ cartItems, setCartItemsCount }) {
  const [subCategories, setSubCategories] = useState({});
  // const [cartItems, setCartItems] = useState(0);
  // const [setIsLoggedIn] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [modalStep, setModalStep] = useState("LOGIN");
  const [isCreated, setIsCreated] = useState(false);
  const [otpError, setOtpError] = useState(""); // State to track OTP errors
  const [resendDisabled, setResendDisabled] = useState(false); // Prevent spamming resend OTP
  const [isMobileReadOnly, setIsMobileReadOnly] = useState(false);
  const [isEmailReadOnly, setIsEmailReadOnly] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const collapseRef = useRef(null);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false); 
  // const searchIconRef = useRef(null);
  const [isBelow483, setIsBelow483] = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(false); 
  const [phoneOtpSent, setPhoneOtpSent] = useState(false); 
  const [emailVerified, setEmailVerified] = useState(false); 
  const [phoneVerified, setPhoneVerified] = useState(false); 
  const [emailOtpError, setEmailOtpError] = useState(""); 
  const [phoneOtpError, setPhoneOtpError] = useState("");

  const [userDetails, setUserDetails] = useState({});
  // const [otp, setOtp] = useState("");
  // const [setIsOtpVerified] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset,} = useForm();
  const { register: registerRegister, handleSubmit: handleRegisterSubmit, setValue, watch,  reset: resetRegisterForm, } = useForm();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState({
    country: "",
    state: "",
    city: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsBelow483(window.innerWidth-4 < 483);
    };
    window.addEventListener("resize", handleResize);
    handleResize(); 
    return () => window.removeEventListener("resize", handleResize);
  }, [isBelow483]);

  const handleSearchClick = (e) => {
    e.stopPropagation(); 
    setShowSearch(!showSearch);
  };
  // Close SearchBar
  const handleSearchClose = () => {
    setShowSearch(false);
  };
   // Toggle Navbar when clicking Hamburger Icon
   const handleNavbarToggle = () => {
    if (collapseRef.current) {
      import("bootstrap").then((bootstrap) => {
        const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseRef.current);
        bsCollapse.toggle(); // Manually toggle navbar
        setIsNavbarOpen(!isNavbarOpen);
      });
    }
  };

  // Close Navbar when clicking a link
  const handleNavLinkClick = () => {
    if (collapseRef.current) {
      import("bootstrap").then((bootstrap) => {
        const bsCollapse = bootstrap.Collapse.getInstance(collapseRef.current);
        if (bsCollapse) {
          bsCollapse.hide();
          setIsNavbarOpen(false); // Update state
        }
      });
    }
  };

  // Close Navbar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        collapseRef.current &&
        isNavbarOpen &&
        !collapseRef.current.contains(event.target) &&
        !event.target.closest(".navbar-toggler")
      ) {
        import("bootstrap").then((bootstrap) => {
          const bsCollapse = bootstrap.Collapse.getInstance(collapseRef.current);
          if (bsCollapse) {
            bsCollapse.hide();
            setIsNavbarOpen(false); // Update state
          }
        });
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isNavbarOpen]);

  const myOrders = () => {
    navigate(`/orders`);
    setShowProfileModal(false);
  };


  const editProfile = () => {
    // Get user details from localStorage
    const storedUserDetails = localStorage.getItem("userDetails");
  
    // Parse JSON data from localStorage
    const parsedUserDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
  
    if (parsedUserDetails) {
      // console.log("📌 User Details Loaded for Editing:", parsedUserDetails);
  
      setValue("userName", parsedUserDetails.username || "");
      setValue("email", parsedUserDetails.email || "");
      setValue("mobile", parsedUserDetails.phone_number || "");
      setValue("address", parsedUserDetails.address || "");
      setValue("pincode", parsedUserDetails.postalCode || "");
      setValue("address_type", parsedUserDetails.address_type || "");
  
      // Make mobile and email readonly if available
      setIsMobileReadOnly(!!parsedUserDetails.phone_number);
      setIsEmailReadOnly(!!parsedUserDetails.email);

      // Make mobile and email varified if available
      setEmailVerified(!!userDetails.email);
      setPhoneVerified(!!userDetails.phone_number);

      const countryData = Country.getAllCountries().find(
        (c) => c.name.toLowerCase() === parsedUserDetails.country.toLowerCase()
      );
      const countryIsoCode = countryData ? countryData.isoCode : "";
  
      let matchedState = null;
      let stateIsoCode = "";
  
      if (countryIsoCode) {
        const countryStates = State.getStatesOfCountry(countryIsoCode);
        matchedState = countryStates.find(
          (s) => s.name.toLowerCase().trim() === parsedUserDetails.state.toLowerCase().trim()
        );
        stateIsoCode = matchedState ? matchedState.isoCode : "";
      }
  
      let matchedCity = null;
  
      if (stateIsoCode) {
        const stateCities = City.getCitiesOfState(countryIsoCode, stateIsoCode);
        matchedCity = stateCities.find(
          (c) => c.name.toLowerCase().trim() === parsedUserDetails.city.toLowerCase().trim()
        );
      }
      // console.log("Extracted Country ISO:", countryIsoCode);
      // console.log("Matched State:", matchedState);
      // console.log("Matched City:", matchedCity);

      setValue("country", parsedUserDetails.country);
      setValue("state", matchedState ? matchedState.name : "");
      setValue("city", matchedCity ? matchedCity.name : "");
  
      handleLocationChange({
        country: parsedUserDetails.country,
        state: matchedState ? matchedState.name : "",
        city: matchedCity ? matchedCity.name : "",
      });
  
      setAddress({
        country: parsedUserDetails.country,
        state: matchedState ? matchedState.name : "",
        city: matchedCity ? matchedCity.name : "",
      });
    }
  
    setIsEditing(true);
    setModalStep("REGISTER"); 
  };
  
  const handleLocationChange = (newAddress) => {
    setAddress(newAddress); // Update address state
    setValue("country", newAddress.country);
    setValue("state", newAddress.state);
    setValue("city", newAddress.city);
  };

  const getCurrentLocation = async () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }
  
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const response = await getUserCurrentLocation({ latitude, longitude });
  
          if (response?.address) {
            console.log("📌 Raw Address Response:", response.address);
  
            const { country_code, state, city, postcode } = response.address;
  
            // ✅ Fetch full country name using country code
            const countryData = Country.getAllCountries().find(
              (c) => c.isoCode.toLowerCase() === country_code.toLowerCase()
            );
  
            const fullCountryName = countryData ? countryData.name : "";
  
            // ✅ Fetch state details using country code
            const countryStates = State.getStatesOfCountry(country_code.toUpperCase());
            const matchedState = countryStates.find(
              (s) => s.name.toLowerCase() === state.toLowerCase() || s.isoCode.toLowerCase() === state.toLowerCase()
            );
  
            const fullStateName = matchedState ? matchedState.name : "";
            const stateIsoCode = matchedState ? matchedState.isoCode : "";
  
            // ✅ Fetch city name using state code
            const stateCities = matchedState
              ? City.getCitiesOfState(country_code.toUpperCase(), stateIsoCode)
              : [];
  
            const matchedCity = stateCities.find(
              (c) => c.name.toLowerCase().includes(city.toLowerCase())
            );
  
            const fullCityName = matchedCity ? matchedCity.name : "";
  
            // ✅ Debug logs to verify extracted values
            console.log("✅ Extracted Location Data:", {
              country: fullCountryName,
              state: fullStateName,
              city: fullCityName,
              pincode: postcode,
            });
  
            // ✅ Ensure values are set correctly in the form
            const newAddress = {
              country: fullCountryName || "",
              state: fullStateName || "",
              city: fullCityName || "",
              pincode: postcode || "",
            };
  
            setAddress(newAddress);
            handleLocationChange(newAddress);
  
            // ✅ Ensure `setValue` updates correctly
            setTimeout(() => {
              setValue("country", newAddress.country);
              setValue("state", newAddress.state);
              setValue("city", newAddress.city);
              setValue("pincode", newAddress.pincode);
            }, 100);
          } else {
            alert("Unable to fetch address from location.");
          }
        } catch (error) {
          console.error("❌ Error fetching location:", error);
          alert("Failed to fetch location details. Please try again.");
        }
      },
      (error) => {
        console.error("❌ Error getting geolocation:", error);
        alert("Unable to retrieve your location.");
      }
    );
  };
  
  // Fetch subcategories and cart items on mount
  useEffect(() => {
    async function fetchSubCategories() {
      try {
        const response = await productSubCategories();
        const categories = response.reduce((acc, subCategory) => {
          const { name } = subCategory.category;
          acc[name] = acc[name] || [];
          acc[name].push(subCategory.name);
          return acc;
        }, {});
        setSubCategories(categories);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    }

    // async function fetchCartItems() {
    //   try {
    //     const response = await getCartItems();
    //     setCartItems(response[0]?.items?.length || 0);
    //   } catch (error) {
    //     console.error("Error fetching cart items:", error);
    //   }
    // }

    fetchSubCategories();
    // fetchCartItems();
    // getCurrentLocation();
  }, []);
  
  // Handle Subcategory Click
  const handleSubCategoryClick = (category, subCategory) => {
    navigate(`/products/${category}`, { state: { subCategory } });
  };

  // Handle Category Click
  const handleCategoryClick = (category) => {
    navigate(`/products/${category}`);
  };

  const handleLoginClick = () => {
    setShowProfileModal(true);
    
    const accessToken = localStorage.getItem("accessToken");
    const storedUserDetails = localStorage.getItem("userDetails");
  
    // Parse JSON data from localStorage
    const parsedUserDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
  
    setUserDetails(parsedUserDetails);
    console.log("User state------>", parsedUserDetails);
  
    if (accessToken !== null && parsedUserDetails) {
      setModalStep("PROFILE");
    } else {
      setModalStep("LOGIN");
    }
  };

  const handleSendOtp = async (data) => {
    try {
      let inputType = "email";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[0-9]{10}$/;
      if (emailRegex.test(data.loginInput)) {
        inputType = "email";
      } else if (phoneRegex.test(data.loginInput)) {
        inputType = "phone";
      }
      const payload = inputType === "email" ? { email: data.loginInput } : { phone_number: data.loginInput };
      const response = await requestOtp(payload);
      setEmail(inputType === "email" ? data.loginInput : "");
      setPhone(inputType === "phone" ? data.loginInput : "");
      console.log("OTP requested successfully:", response);
  
      // Check if `user-created` exists in the response and update `setIscreate`
      if (response?.data?.["user-created"] !== undefined) {
        setIsCreated(response.data["user-created"]);
      };
      // console.log("isCreated",isCreated);
      reset();
      setModalStep("VERIFY_OTP");
    } catch (error) {
      console.error("Failed to request OTP:", error);
    }
  };
  
  const handleVerifyOtp = async (data) => {
    try {
      let inputType = "email";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[0-9]{10}$/;
      if (emailRegex.test(email)) {
        inputType = "email";
      } else if (phoneRegex.test(phone)) {
        inputType = "phone";
      }
      const guestUserId = localStorage.getItem("guest_user_id");

      const payload = {
        [inputType === "email" ? "email" : "phone_number"]: inputType === "email" ? email : phone,
        otp: data.otp,
        guestUserId: guestUserId,
      };
      const response = await loginRegisterVerifyOtp(payload);
  
      if (response && response.tokens) {
        // Save tokens to localStorage
        localStorage.setItem('accessToken', response.tokens.access);
        localStorage.setItem('refreshToken', response.tokens.refresh);
  
        // Clear guest_user_id from localStorage
        localStorage.removeItem("guest_user_id");
  
        console.log("OTP verified successfully. Tokens saved and guest_user_id cleared:", response);
  
        if (isCreated) {
          setModalStep("REGISTER");
        } else {
          const userAddresses = await fetchUserAddresses();
          const userDetails = await fetchUserDetails();
          
          if (Array.isArray(userAddresses) && userAddresses.length === 0) {
            setModalStep("REGISTER");
            setValue("mobile", userDetails?.phone_number || "");
            setValue("userName", userDetails.username || "");
            setValue("email", userDetails.email || "");
            //  Make mobile readonly if available
            setIsMobileReadOnly(!!userDetails.phone_number);
            setPhoneVerified(!!userDetails.phone_number);
            //  Make mobile readonly if available
            setIsEmailReadOnly(!!userDetails.email);
            setEmailVerified(!!userDetails.email);
          } else {
            const currentAddresses = userAddresses.filter((address) => address.is_current === true);
            console.log("currentAddress", currentAddresses);
            
            const userData = {
              username: userDetails?.username || null,
              email: userDetails?.email || null,
              phone_number: userDetails?.phone_number || null,
              addressId:currentAddresses[0]?.id || null,
              address: currentAddresses[0]?.address_line_1 || null,
              address_type: currentAddresses[0]?.address_type || null,
              city: currentAddresses[0]?.city || null,
              postalCode: currentAddresses[0]?.postal_code || null,
              state: currentAddresses[0]?.state || null,
              country: currentAddresses[0]?.country || null
            };
  
            setUserDetails(userData);
            localStorage.setItem('userDetails', JSON.stringify(userData));
            const response = await getCartItems();
            setCartItemsCount(response[0]?.items?.length || 0);
            setModalStep("PROFILE");
          }
          console.log('userAddresses', userAddresses, 'userDetails', userDetails);
        }
        reset(); // Reset OTP form
        setOtpError(""); // Clear OTP error if successful
      } else {
        throw new Error("Invalid OTP");
      }
    } catch (error) {
      console.error("Failed to verify OTP:", error);
      setOtpError("Invalid OTP. Please try again."); // Show OTP error
    }
  };
  
  const handleSendPhoneOtp = async (phoneValue) => {
    try {
      const payload = { phone_number: phoneValue };
      // console.log("Sending OTP payload:", payload);
      const response = await updateUser(payload);
      // console.log("Phone OTP response:", response);
  
      if (!response.success) {
        // Parse the error string to extract the nested message
        let errorMessage = "Failed to send OTP. Please try again.";
        try {
          const errorObj = JSON.parse(response.error.split(": ")[1]);
          errorMessage = errorObj.message || errorMessage;
        } catch (parseError) {
          console.error("Failed to parse error message:", parseError);
          errorMessage = response.error || errorMessage;
        }
        throw new Error(errorMessage);
      }
  
      console.log("Phone OTP sent successfully:", response);
      setPhoneOtpSent(true);
      setPhoneOtpError("");
    } catch (error) {
      console.error("Failed to send phone OTP:", error);
      // Use error.message directly, as it contains the parsed message
      const errorMessage =
        error.message || "Failed to send OTP. Please try again.";
      setPhoneOtpError(errorMessage);
    }
  };
  
  const handleSendEmailOtp = async (emailValue) => {
    try {
      const payload = { email: emailValue };
      console.log("Sending OTP payload:", payload);
      const response = await updateUser(payload); 
      console.log("Email OTP response:", response);
  
      if (!response.success) {
        let errorMessage = "Failed to send OTP. Please try again.";
        try {
          const errorObj = JSON.parse(response.error.split(": ")[1]);
          errorMessage = errorObj.message || errorMessage;
        } catch (parseError) {
          console.error("Failed to parse error message:", parseError);
          errorMessage = response.error || errorMessage;
        }
        throw new Error(errorMessage);
      }
  
      console.log("Email OTP sent successfully:", response);
      setEmailOtpSent(true);
      setEmailOtpError("");
    } catch (error) {
      console.error("Failed to send email OTP:", error);
      const errorMessage =
        error.message || "Failed to send OTP. Please try again.";
      setEmailOtpError(errorMessage);
    }
  };

  const handleVerifyPhoneOtp = async (otp) => {
    try {
      const payload = {
        channel: "phone",
        otp_code: otp,
      };
      console.log("Verifying OTP payload:", payload);
      const response = await VerifyOtpAfterLogin(payload);
      // const response = await loginRegisterVerifyOtp(payload);
      console.log("Phone OTP verification response:", response);
      if (response && response.success) {
        console.log("Phone OTP verified successfully:", response);
        setPhoneVerified(true);
        setPhoneOtpSent(false);
        setPhoneOtpError("");
        setUserDetails((prev) => ({ ...prev, phone_number_verified: true }));
      } else {
        throw new Error("Invalid OTP");
      }
    } catch (error) {
      console.error("Failed to verify phone OTP:", error);
      setPhoneOtpError("Invalid OTP. Please try again.");
    }
  };

  const handleVerifyEmailOtp = async (otp) => {
    try {
      const payload = {
        channel: "email",
        otp_code: otp,
      };
      console.log("Verifying OTP payload:", payload);
      const response = await VerifyOtpAfterLogin(payload);
      if (response && response.success) {
        console.log("Email OTP verified successfully:", response);
        setEmailVerified(true);
        setEmailOtpSent(false);
        setEmailOtpError("");
        setUserDetails((prev) => ({ ...prev, email_verified: true }));
      } else {
        throw new Error("Invalid OTP");
      }
    } catch (error) {
      console.error("Failed to verify email OTP:", error);
      setEmailOtpError("Invalid OTP. Please try again.");
    }
  };

  const handleRegister = async (formData) => {
    try {
      const addressPayload = {
        city: formData.city,
        address_line_1: formData.address,
        state: formData.state,
        country: formData.country,
        postal_code: formData.pincode,
        address_type: formData.address_type,
      };
  
      const userPayload = {
        username: formData.userName, 
      };
      
      if (formData.mobile) {
        userPayload.mobile = formData.mobile;
      }
  
      let userResult;
      let addressResult;
  
      const hasUserDetails = userDetails && userDetails.addressId;
  
      if (isEditing && hasUserDetails) {
        addressResult = await updateAddress(userDetails.addressId, addressPayload);
        userResult = await updateUser(userPayload);
        setIsEditing(false);
      } else {
        addressResult = await addAddress(addressPayload);
        userResult = await updateUser(userPayload);
      }
  
      if (!addressResult.success) {
        console.error(" Address addition failed:", addressResult.error);
        console.log("userResult",userResult);
      }
      const userInfo = await fetchUserDetails();
  
      const userData = {
        username: userInfo?.username || null,
        email: userInfo?.email || null,
        phone_number: userInfo?.phone_number || null,
        addressId: addressResult?.data?.id || null,
        address: addressResult?.data?.address_line_1 || null,
        address_type: addressResult?.data?.address_type || null,
        city: addressResult?.data?.city || null,
        postalCode: addressResult?.data?.postal_code || null,
        state: addressResult?.data?.state || null,
        country: addressResult?.data?.country || null,
      };
  
      setUserDetails(userData);
      localStorage.setItem("userDetails", JSON.stringify(userData));
      setModalStep("PROFILE");
      const response = await getCartItems();
      setCartItemsCount(response[0]?.items?.length || 0);
      resetRegisterForm();
  
      console.log(" Address added successfully:", addressResult.data);
    } catch (error) {
      console.error(" Error in registration process:", error);
      resetRegisterForm(); 
    }
  };
  
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userDetails");
  
    setUserDetails(null);
  
    setShowProfileModal(false);
    navigate("/"); 
    console.log("User logged out successfully");
  };

  const handleResendOtp = async () => {
    try {
      setResendDisabled(true); 
      const response = await requestOtp({ email });
      console.log("OTP resent successfully:", response);
  
      
      setTimeout(() => setResendDisabled(false), 30000);
  
      setOtpError("");
    } catch (error) {
      console.error("Failed to resend OTP:", error);
      setOtpError("Failed to resend OTP. Please try again later.");
    }
  };
  
  const renderModalContent = () => {
    switch (modalStep) {
      case "LOGIN":
        return (
          <div>
            <h4>Login/Register</h4>
            <form onSubmit={handleSubmit(handleSendOtp)}>
              <div style={{ marginBottom: "15px" }}>
                <input
                  type="text"
                  id="loginInput"
                  placeholder="Enter Email or Phone Number"
                  {...register("loginInput", {
                    required: "Email or phone number is required",
                    validate: (value) => {
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      const phoneRegex = /^[0-9]{10}$/;
                      console.log("Validating input:", value); 
                      if (emailRegex.test(value)) {
                        // setInputType("email");
                        setEmail(value);
                        setPhone(""); 
                        return true;
                      } else if (phoneRegex.test(value)) {
                        // setInputType("phone");
                        setPhone(value);
                        setEmail("");
                        return true;
                      }
                      return "Enter a valid email or 10-digit phone number";
                    },
                  })}
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginBottom: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                  }}
                />
                {errors.loginInput && <p className="text-danger">{errors.loginInput.message}</p>}
              </div>
              <div>
                <button type="submit" className="btn btn-primary w-100">
                  Send OTP
                </button>
              </div>
            </form>
          </div>
        );
      case "VERIFY_OTP":
        return (
          <div>
            {/* <h4>Verify OTP</h4> */}
            <form onSubmit={handleSubmit(handleVerifyOtp)}>
              <div style={{ marginBottom: "15px", marginTop:"30px" }}>
                <input
                  type="number"
                  placeholder="Enter OTP"
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginBottom: "10px",
                    border: otpError ? "1px solid red" : "1px solid #ddd",
                    borderRadius: "5px",
                  }}
                  {...register("otp", {
                    required: "OTP is required",
                    minLength: { value: 6, message: "OTP must be 6 characters" },
                    maxLength: { value: 6, message: "OTP must be 6 characters" },
                    pattern: { value: /^\d{6}$/, message: "OTP must be numeric" },
                  })}
                />
                {errors.otp && (
                  <p style={{ color: "red", marginTop: "5px" }}>{errors.otp.message}</p>
                )}
                {otpError && (
                  <p style={{ color: "red", marginTop: "5px" }}>{otpError}</p>
                )}
              </div>
      
              <div>
                <button type="submit" className="btn btn-primary w-100">
                  Verify OTP
                </button>
              </div>
            </form>
      
            {/* Resend OTP Option */}
            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <p>Didn't receive the OTP?</p>
              <button
                className="btn btn-secondary"
                onClick={handleResendOtp}
                disabled={resendDisabled}
              >
                {resendDisabled ? "Resend OTP in 30s" : "Resend OTP"}
              </button>
            </div>
          </div>
        );
      case "REGISTER":
        return (
          <>
            <div className="mx-auto">
              <div className="rounded bg-white">
                <h5 className="mb-4">Enter your details</h5>
                <div className="form-container">
                  <form onSubmit={handleRegisterSubmit(handleRegister)}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Name"
                        {...registerRegister("userName", { required: "Name is required" })}
                      />
                      {errors.userName && <p className="text-danger">{errors.userName.message}</p>}
                    </div>

                    {/* Email Field with OTP Verification */}
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <div className="position-relative">
                        {userDetails?.email_verified || emailVerified ? (
                          <div className="position-relative">
                            <input
                              type="text"
                              placeholder="Email"
                              readOnly
                              className="form-control"
                              style={{
                                width: "100%",
                                padding: "10px 40px 10px 10px",
                                marginBottom: "10px",
                              }}
                              {...registerRegister("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                  message: "Enter a valid email",
                                },
                              })}
                            />
                            <span
                              className="material-icons position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "green",
                                fontSize: "24px",
                              }}
                              title="Verified"
                            >
                              check_circle
                            </span>
                          </div>
                        ) : (
                          <div className="position-relative">
                            <input
                              type="text"
                              placeholder="Email"
                              readOnly={isEmailReadOnly || emailVerified}
                              className="form-control"
                              style={{
                                width: "100%",
                                padding: `10px ${emailOtpSent ? "45%" : "45%"} 10px 10px`,
                                marginBottom: "10px",
                              }}
                              {...registerRegister("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                  message: "Enter a valid email",
                                },
                              })}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                setEmailOtpSent(false); 
                                setEmailVerified(false);
                              }}
                            />
                            {emailOtpSent ? (
                              <div
                                className="position-absolute"
                                style={{
                                  right: "0px",
                                  top: "0%",
                                  width: "45%",
                                  display: "flex",
                                  alignItems: "center",
                                  height: "45px",
                                }}
                              >
                                <input
                                  type="number"
                                  placeholder="OTP"
                                  className="form-control"
                                  style={{
                                    width: "60%",
                                    padding: "5px",
                                    fontSize: "14px",
                                    marginRight: "0px",
                                    height: "45px",
                                    marginBottom: "0px",
                                  }}
                                  {...registerRegister("emailOtp", {
                                    required: "OTP is required",
                                    pattern: {
                                      value: /^\d{6}$/,
                                      message: "Enter a valid 6-digit OTP",
                                    },
                                  })}
                                />
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  style={{
                                    width: "40%",
                                    padding: "5px 0px",
                                    fontSize: "14px",
                                    height: "45px",
                                  }}
                                  onClick={() => handleVerifyEmailOtp(watch("emailOtp"))}
                                >
                                  Verify OTP
                                </button>
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-secondary position-absolute"
                                style={{
                                  right: "0px",
                                  top: "0%",
                                  width: "35%",
                                  padding: "10px",
                                  fontSize: "14px",
                                  height: "45px",
                                  backgroundColor: "#0d6efd"
                                }}
                                onClick={() => handleSendEmailOtp(watch("email"))}
                                disabled={isEmailReadOnly || emailVerified}
                              >
                                Verify
                              </button>
                            )}
                            {errors.email && <p className="text-danger">{errors.email.message}</p>}
                            {errors.emailOtp && <p className="text-danger">{errors.emailOtp.message}</p>}
                            {emailOtpError && <p className="text-danger">{emailOtpError}</p>}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Mobile Number Field with OTP Verification */}
                    <div className="mb-3">
                      <label htmlFor="mobile" className="form-label">
                        Mobile number
                      </label>
                      <div className="position-relative">
                        {userDetails?.phone_number_verified || phoneVerified ? (
                          <div className="position-relative">
                            <input
                              type="tel"
                              placeholder="Enter 10-digit mobile number"
                              readOnly
                              className="form-control"
                              style={{
                                width: "100%",
                                padding: "10px 40px 10px 10px",
                                marginBottom: "10px",
                              }}
                              {...registerRegister("mobile", {
                                required: "Mobile number is required",
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message: "Enter a valid 10-digit mobile number",
                                },
                              })}
                            />
                            <span
                              className="material-icons position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "green",
                                fontSize: "24px",
                              }}
                              title="Verified"
                            >
                              check_circle
                            </span>
                          </div>
                        ) : (
                          <div className="position-relative">
                            <input
                              type="tel"
                              placeholder="Enter 10-digit mobile number"
                              readOnly={isMobileReadOnly || phoneVerified}
                              className="form-control"
                              style={{
                                width: "100%",
                                padding: `10px ${phoneOtpSent ? "45%" : "45%"} 10px 10px`,
                                marginBottom: "10px",
                              }}
                              {...registerRegister("mobile", {
                                required: "Mobile number is required",
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message: "Enter a valid 10-digit mobile number",
                                },
                              })}
                              onChange={(e) => {
                                setPhone(e.target.value);
                                setPhoneOtpSent(false); // Reset OTP state if phone changes
                                setPhoneVerified(false); // Reset verification state
                              }}
                            />
                            {phoneOtpSent ? (
                              <div
                                className="position-absolute"
                                style={{
                                  right: "0px",
                                  top: "0%",
                                  width: "45%",
                                  display: "flex",
                                  alignItems: "center",
                                  height: "45px",
                                }}
                              >
                                <input
                                  type="number"
                                  placeholder="Enter OTP"
                                  className="form-control"
                                  style={{
                                    width: "60%",
                                    padding: "5px",
                                    fontSize: "14px",
                                    marginRight: "0px",
                                    height: "45px",
                                    marginBottom: "0px",
                                  }}
                                  {...registerRegister("phoneOtp", {
                                    required: "OTP is required",
                                    pattern: {
                                      value: /^\d{6}$/,
                                      message: "Enter a valid 6-digit OTP",
                                    },
                                  })}
                                />
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  style={{
                                    width: "40%",
                                    padding: "5px 0px",
                                    fontSize: "14px",
                                    height: "45px",
                                  }}
                                  onClick={() => handleVerifyPhoneOtp(watch("phoneOtp"))}
                                >
                                  Verify OTP
                                </button>
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-secondary position-absolute"
                                style={{
                                  right: "0px",
                                  top: "0%",
                                  width: "35%",
                                  padding: "10px",
                                  fontSize: "14px",
                                  height: "45px",
                                  backgroundColor: "#0d6efd"
                                }}
                                onClick={() => {
                                  handleSendPhoneOtp(watch("mobile"));
                                }}
                                disabled={isMobileReadOnly || phoneVerified}
                              >
                                Verify
                              </button>
                            )}
                            {errors.mobile && <p className="text-danger">{errors.mobile.message}</p>}
                            {errors.phoneOtp && <p className="text-danger">{errors.phoneOtp.message}</p>}
                            {phoneOtpError && <p className="text-danger">{phoneOtpError}</p>}
                          </div>
                        )}
                      </div>
                    </div>
      
                    <div className="mb-3">
                      <div>
                        <label htmlFor="address" className="form-label">
                          Address (Area and Street)
                        </label>
                        <button
                          type="button"
                          className="btn btn-primary m-0 p-0 px-2 float-end size-getcurrent-button"
                          onClick={getCurrentLocation}
                        >
                          <span
                            className="material-icons me-2"
                            style={{ color: "#FFF", fontSize: "14px" }}
                          >
                            my_location
                          </span>
                          Current Location
                        </button>
                      </div>
                      <textarea
                        className="form-control"
                        id="address"
                        rows="2"
                        placeholder="Address (Area and Street)"
                        {...registerRegister("address", { required: "Address is required" })}
                      ></textarea>
                      {errors.address && <p className="text-danger">{errors.address.message}</p>}
                    </div>
                    {/* Country-State-City Selector */}
                    <CountryStateCitySelector
                      onChange={handleLocationChange}
                      countryValue={address.country}
                      stateValue={address.state}
                      cityValue={address.city}
                    />
      
                    <div className="mb-3">
                      <label htmlFor="pincode" className="form-label">
                        Pincode
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="pincode"
                        placeholder="Pincode"
                        {...registerRegister("pincode", {
                          required: "Pincode is required",
                          pattern: {
                            value: /^[1-9][0-9]{5}$/,
                            message: "Enter a valid 6-digit pincode",
                          },
                        })}
                      />
                      {errors.pincode && <p className="text-danger">{errors.pincode.message}</p>}
                    </div>

                    {/* <div className="mb-3">
                      <label htmlFor="alternate-phone" className="form-label">
                        Alternate Mobile Number
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="alternate-phone"
                        placeholder="Alternate Mobile Number"
                        {...registerRegister("alternateMobile", {
                          pattern: {
                            value: /^[0-9]{10}$/,
                          },
                          message: "Enter a valid 10-digit mobile number",
                        })}
                      />
                    </div> */}
      
                    <div className="mb-3 d-flex align-items-center">
                      <label className="form-label me-3 mb-0">Address Type:</label>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="address_type"
                          id="home"
                          value="home"
                          {...registerRegister("address_type", { required: "Select an address type" })}
                          checked={watch("address_type") === "home"}
                        />
                        <label className="form-check-label" htmlFor="home">
                          Home
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="address_type"
                          id="work"
                          value="work"
                          {...registerRegister("address_type", { required: "Select an address type" })}
                          checked={watch("address_type") === "work"}
                        />
                        <label className="form-check-label" htmlFor="work">
                          Work
                        </label>
                      </div>
                      {errors.address_type && (
                        <p className="text-danger">{errors.address_type.message}</p>
                      )}
                    </div>
      
                    <div className="d-flex justify-content-end">
                      <button type="button" className="btn btn-warning w-25 me-2" 
                      onClick={()=>{
                        setModalStep("PROFILE");
                        setIsEditing(false);
                      }}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary w-25">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        );
      case "PROFILE":
        return (
            <>
              <div className="">
                {/* <div className="d-flex flex-column align-items-center ">
                  <img
                    src="profile-pic.jpg"
                    alt=""
                    className="profile-image"
                  />
                </div> */}
                <div className="d-flex flex-sm-row flex-column justify-content-evenly align-items-center mt-3 gap-2"> 
                  
                  <button 
                    className="btn btn-custom-login me-2 btn-sm px-2 py-1 text-center d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip" 
                    data-bs-placement="top" 
                    title="Order Details"
                    onClick={myOrders}
                  >
                    <span className="material-icons me-2">receipt_long</span> 
                    My Orders
                  </button>

                    <button 
                      className="btn btn-custom-login me-2 btn-sm px-2 py-1 text-center d-flex align-items-center justify-content-center" 
                      data-bs-toggle="tooltip" 
                      data-bs-placement="top" 
                      title="Edit Profile"
                      onClick={editProfile}
                    >
                      <span className="material-icons me-2" style={{ fontSize: "24px" }}>edit</span> Edit 
                    </button>

                    <button 
                      className="btn btn-custom-login me-2 btn-sm px-2 py-1 text-center d-flex align-items-center justify-content-center" 
                      data-bs-toggle="tooltip" 
                      data-bs-placement="top" 
                      title="Logout"
                      onClick={handleLogout}
                    >
                      <span className="material-icons me-2">logout</span> Logout
                    </button>
                </div>

                <div className="form-container mt-3">
                  <div className="profile-card">
                    <div className="info-card">
                      <p className="info-label-login">Name :</p>
                      <p className="info-value-login">{userDetails?.username || ""}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">Email :</p>
                      <p className="info-value-login">{userDetails?.email || ""}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">Mobile Number :</p>
                      <p className="info-value-login">{userDetails?.phone_number || ""}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">Address :</p>
                      <p className="info-value-login">{userDetails?.address || ""}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">Country :</p>
                      <p className="info-value-login">{userDetails?.country || ""}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">State :</p>
                      <p className="info-value-login">{userDetails?.state || ""}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">City :</p>
                      <p className="info-value-login">{userDetails?.city || " "}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">Pincode :</p>
                      <p className="info-value-login">{userDetails?.postalCode || " "}</p>
                    </div>
                    <div className="info-card">
                      <p className="info-label-login">Address Type :</p>
                      <p className="info-value-login">{userDetails?.address_type || " "}</p>
                    </div>
                  </div>
                </div>
              </div>
            </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top">
        <div className="container-fluid">
          {/* Logo */}
          <Link className="navbar-brand" to="/">
            <img src={vastuSalahkar4} alt="Logo" className="navbar-logo" />
          </Link>
          {/* Mobile Header with SearchBar and Icons */}
          <div className="navbar-mobile-header d-lg-none d-flex align-items-center">
            {/* Below 483px: Show icons only, SearchBar on click */}
            {isBelow483 ? (
              <div className="d-flex align-items-center gap-3">
                <span className="material-icons" title="Search" onClick={handleSearchClick}>search</span>
                <span
                  className="material-icons"
                  title="Profile"
                  onClick={() => {
                    handleNavLinkClick();
                    handleLoginClick();
                  }}
                >
                  person
                </span>
                <div
                  className="cart-icon d-flex align-items-center"
                  onClick={() => {
                    handleNavLinkClick();
                    navigate("/cart");
                  }}
                >
                  <span className="material-icons" title="Cart">shopping_cart</span>
                  {cartItems > 0 && <span className="cart-count">{cartItems}</span>}
                </div>
              </div>
            ) : (
              /* Between 483px and 991px: Show SearchBar always */
              <>
                <div className="mobile-search-bar">
                  <SearchBar />
                </div>
                <div className="navbar-icons-mobile d-flex align-items-center">
                  <span
                    className="material-icons"
                    title="Profile"
                    onClick={() => {
                      handleNavLinkClick();
                      handleLoginClick();
                    }}
                  >
                    person
                  </span>
                  <div
                    className="cart-icon d-flex align-items-center"
                    onClick={() => {
                      handleNavLinkClick();
                      navigate("/cart");
                    }}
                  >
                    <span className="material-icons" title="Cart">shopping_cart</span>
                    {cartItems > 0 && <span className="cart-count">{cartItems}</span>}
                  </div>
                </div>
              </>
            )}
          </div>
          {/* Hamburger Icon for Mobile */}
          <button
            className="navbar-toggler"
            type="button"
            aria-controls="navbarNav"
            aria-expanded={isNavbarOpen}
            aria-label="Toggle navigation"
            onClick={handleNavbarToggle} // Call the toggle function
          >

            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar Menu */}
          <div className="collapse navbar-collapse" id="navbarNav" ref={collapseRef}>
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={handleNavLinkClick}>Home</Link>
              </li>
              {["plants", "products", "combos"].map((category) => (
                <li className="nav-item dropdown" key={category}>
                  <Link
                    className="nav-link dropdown-toggle"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    // to={`/products/${category}`} 
                    onClick={(e) => {
                      if (window.innerWidth < 992) {
                        handleCategoryClick(category);
                      }
                      else{
                        handleNavLinkClick();
                        handleCategoryClick(category);
                      }
                    }}
                  >
                    {category.charAt(0).toUpperCase() + category.slice(1).replace("_", " ")}
                  </Link>
                  <ul className="dropdown-menu" aria-labelledby={category}>
                    {subCategories[category]?.map((sub, idx) => (
                      <li key={idx}>
                        <span
                          className="dropdown-item"
                          onClick={() => {
                            handleNavLinkClick();
                            handleSubCategoryClick(category, sub)
                          }}
                        >
                          {sub}
                        </span>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
              <li className="nav-item">
                <Link className="nav-link" to="/about" onClick={handleNavLinkClick}>About Us</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/recommendations" onClick={handleNavLinkClick}>Vastu Recommendations</Link>
              </li>
            </ul>

            {/* Navbar Icons */}
            <div className="navbar-icons d-none d-lg-flex align-items-center justify-content-center mt-3 pe-2">
              {/* Search */}
              {/* <span className="material-icons" title="Search" onClick={handleNavLinkClick}>search</span> */}
              <span className="material-icons" title="Search" onClick={handleSearchClick}>
                  search
              </span>

              {/* <SearchBar /> */}

              {/* <SearchBar /> */}
              {/* Profile */}
              <span
                className="material-icons"
                title="Profile"
                onClick={() => { 
                  handleNavLinkClick();
                  handleLoginClick();
                }}
              >
                person
              </span>

              {/* Cart */}
              <div className="cart-icon d-flex align-items-center justify-content-center pe-2" onClick={() => { handleNavLinkClick(); navigate("/cart"); }}>
                <span className="material-icons" title="Cart">
                  shopping_cart
                </span>
                {cartItems > 0 && <span className="cart-count">{cartItems}</span>}
              </div>

            </div>
          </div>
        </div>

        {/* Profile Modal */}
        {showProfileModal && (
          <div className="modal-overlay">
            <div className="profile-modal">
              {isEditing?(<button
                className="btn btn-custom-back-button d-flex align-items-center justify-content-center pe-2"
                onClick={() => {
                  setModalStep("PROFILE");
                  setIsEditing(false);
                }}
              >
                <span
                  className="material-icons me-2"
                >
                  arrow_back
                </span> Back
              </button>):(<button
                className="btn-close outline-none shadow-none border-none"
                aria-label="Close"
                onClick={() => {
                  setShowProfileModal(false);
                  setIsEditing(false);
                }}
              >
              </button>)}
              {renderModalContent()}
            </div>
          </div>
        )}


      </nav>
      {/* SearchBar for toggling (below 483px and above 991px) */}
      {showSearch && (
        <div className="search-bar-container">
          <SearchBar onClose={handleSearchClose} />
        </div>
      )}
    </>
  );
}

export default Navbar;
